import React, { useState } from "react";
import {
  CancelButton,
  SubmitMapButton,
  BackArrowButton,
  CloseButton,
} from "../../../fixedassetelements/button/Button";
import AddIcon from "../../../assets/icons/addEcl.svg";
import { CiCircleQuestion } from "react-icons/ci";
import AddField from "../AddField/AddField";
import Category from "./Category";
import Currency from "./Currency";
import commonstyles from "../Forms.module.css";
import styles from "./SubMapping.module.css";
import { patchSaleSubmapping } from "../../../../Bookclosure/Services/ApiHandler";

export default function Submapping({ onBack, onClose, onCancel, SaleID, onMapped }) {
  const [activeTab, setActiveTab] = useState("currency");
  const [showAddFieldPopup, setShowAddFieldPopup] = useState(false);
  const [categorySubmap, setCategorySubmap] = useState([]);
  const [currencySubmap, setCurrencySubmap] = useState({});

 const handleSubmit = async () => {
  const formattedPayload = {
    currencySubmap: Object.keys(currencySubmap)
      .filter((key) => !key.startsWith("closingRate"))
      .map((key) => {
        const dropdownValue = currencySubmap[key];
        const closingRate =
          currencySubmap[`closingRate${key.toUpperCase()}`];

        const values = [];

        if (dropdownValue) values.push(dropdownValue);
        if (closingRate) values.push(closingRate); 

        return {
          key: key.toUpperCase(),
          values,
        };
      })
      .filter((item) => item.values.length > 0),
  };

  try {
    const res = await patchSaleSubmapping(SaleID, formattedPayload);
    console.log("Submapping updated", res.data);
    if (onMapped) {
      onMapped();
    } else {
      onClose();
    }
  } catch (err) {
    console.error("Error Update Submapping:", err);
  }
};

  return (
    <>
      <div className={commonstyles.backdrop}>
        <div className={`${commonstyles.container} ${styles.mediumContainer}`}>
          <div className={styles.header}>
            <div className={styles.subheader}>
              <BackArrowButton onClick={onBack} />
              <h2 className={styles.heading}>Sub Mapping</h2>
            </div>

            <div className={styles.headerRight}>
              <div
                className={styles.addSection}
                onClick={() => setShowAddFieldPopup(true)}
              >
                <img src={AddIcon} alt="Add" className={styles.addIcon} />
                <span className={styles.addField}>Add Field</span>
              </div>
              <CloseButton onClick={onClose} />
            </div>
          </div>

          <div className={styles.toggle}>
            {/* <button
              className={`${styles.toggleButton} ${
                activeTab === "category" ? styles.toggleButtonActive : ""
              }`}
              onClick={() => setActiveTab("category")}
            >
              Category
            </button> */}
            <button
              className={`${styles.toggleButton} ${
                activeTab === "currency" ? styles.toggleButtonActive : ""
              }`}
              onClick={() => setActiveTab("currency")}
            >
              Currency
            </button>
          </div>
          <div className={styles.infoBox}>
            <CiCircleQuestion className={styles.infoIcon} />
            <p className={styles.infoText}>
              You may map multiple columns to a single field, but once a column
              is mapped, it cannot be assigned to any other field.
            </p>
          </div>

          <div className={styles.content}>
            {/* {activeTab === "category" ? (
              <Category SaleID={SaleID} onMappingChange={setCategorySubmap} />
            ) : ( */}
              <Currency SaleID={SaleID} onMappingChange={setCurrencySubmap} />
            {/* )} */}
          </div>

          <div className={commonstyles.footer}>
            <CancelButton onClick={onCancel} />
            <SubmitMapButton onClick={handleSubmit} />
          </div>
        </div>
      </div>

      {showAddFieldPopup && (
        <AddField onClose={() => setShowAddFieldPopup(false)} />
      )}
    </>
  );
}